module.exports = __webpack_public_path__ + "static/media/gym.1e1747f0.svg";